// extracted by mini-css-extract-plugin
module.exports = {"title":"Matterport_title__32LSi","section":"Matterport_section__1NVoi"};